import * as Util from '@/util.ts';

const maxGenericStringLength: number = 500;

export enum eValidationRules {
  requiredGenericStringRules = 'requiredGenericStringRules',
  genericStringRules = 'genericStringRules',
  requiredPhoneRules = 'requiredPhoneRules',
  requiredEmailRules = 'requiredEmailRules',
  phoneRules = 'phoneRules',
  requiredPostalCodeRules = 'requiredPostalCodeRules',
  required = 'required',
}

interface ValidationRules {
  [ruleName: string]: ValidationFunc[]; // rule key, properties value
}

type ValidationFunc = (v: string) => true | string;

const validationRules: ValidationRules = {
  requiredGenericStringRules: [
    (v: string) => !!v || Util.t?.isRequired,
    (v: string) => v ? v.length < maxGenericStringLength || Util.t?.mustBeLessThan.supplant([maxGenericStringLength.toString()]) : true,
  ],
  genericStringRules: [
    (v: string) => v ? v.length < maxGenericStringLength || Util.t?.mustBeLessThan.supplant([maxGenericStringLength.toString()]) : true,
  ],
  requiredPhoneRules: [
    (v: string) => !!v || Util.t?.isRequired,
    (v: string) => v ? /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(v) || Util.t?.mustBeValidPhoneNumber : true,
  ],
  phoneRules: [
    (v: string) => v ? /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(v) || Util.t?.mustBeValidPhoneNumber : true,
  ],
  requiredPostalCodeRules: [
    (v: string) => !!v || Util.t?.isRequired,
    (v: string) => v ? /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(v) || Util.t?.mustBeValidPostalCode : true,
  ],
  requiredEmailRules: [
    (v: string) => !!v || Util.t?.isRequired,
    (v: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) || Util.t?.mustBeAValidEmail,
  ],
  required: [
    (v: string) => !!v || Util.t?.isRequired,
  ],
};

type FormValidationMapping = Array<[eValidationRules, string[]]>; // rule key, properties value

export const isFormValid = (vueComponent: any, formData: any, mapping: FormValidationMapping, quietValidation = false) => {

  let isValid = false;

  const isPropertyValid = (str: any, ruleSet: ValidationFunc[]) => {
    return ruleSet.every((rule: ValidationFunc) => {
      const result = rule(formData[str]);
      const formElement = vueComponent.$refs[str];
      if (result !== true) {  // Will be a string if false.
        if (!quietValidation) {
          Util.showError(Util.t?.validationError.supplant([Util.t[str], result]));
          if (formElement) {
            vueComponent.$refs[str].classList.add('show-error');
          }
        }
        return false;
      }
      if (formElement) {
        vueComponent.$refs[str].classList.remove('show-error');
      }
      return true;
    });
  };

  isValid = mapping.every(([rule, propertyArray]) => {
    // Check that every property in every property array passes.
    return propertyArray.every((property) => {
      return isPropertyValid(property, validationRules[rule]);
    });
  });

  return isValid;
};
